import React from "react";
import img1 from "../assets/images/icon-01.png";
import img2 from "../assets/images/icon-02.png";
import img3 from "../assets/images/icon-03.png";
import Typewriter from "typewriter-effect";

const About = () => {
  const data = [
    {
      img: img1,
      title: "Website Development",
      desc:
        "Responsive and robust website development with modern libraries and frameworks. Professionally designed and well optimised for mobile browsers.",
    },
    {
      img: img2,
      title: "Mobility Applications",
      desc:
        "High performance native and hybrid mobile applications with intuitive user interfaces. Integrated with latest accessibility features and payment gateways.",
    },
    {
      img: img3,
      title: "Java Applications",
      desc:
        "Multi-threaded, consitent Java applications built for enterprises. Reliable, scalable and secure Java backend services to handle heavy duty tasks.",
    }
  ];

  const type = (typewriter) => {
    typewriter
      .pauseFor(1200)
      .typeString("Hi there!")
      .pauseFor(500)
      .deleteAll()
      .typeString("Welcome to my <br /> Page.")
      .pauseFor(500)
      .deleteAll()
      .typeString("My name is <br /> Shivam")
      .pauseFor(500)
      .deleteAll()
      .typeString("and I am a")
      .pauseFor(500)
      .deleteAll()
      .typeString("Web <br /> Developer.")
      .pauseFor(2200)
      .callFunction(() => {
        document.getElementsByClassName(
          "Typewriter__cursor"
        )[0].style.display = "none";
      })
      .start();
  }

  return (
    <div className="slider-wrapper">
      <div className="slider-activation">
        <div
          className="slide slide-style-1 slider-fixed--height d-flex align-items-center bg_image bg_image--1"
          data-black-overlay="6"
        >
          <div className="container position-relative">
            <div className="row">
              <div className="col-lg-12 col-lg-12-2">
                <div className="inner minht">
                  <h1 className="title theme-gradient">
                    <Typewriter
                      cursor="X"
                      onInit={type}
                    />
                  </h1>
                </div>
              </div>
            </div>
            <div className="service-wrapper service-white show-on-scroll">
              <div className="row">
                {data.map((item,i)=>{
                  return (
                    <div key={item.title.replace(/\s/g, "")+i} className="col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="service service__style--1">
                        <div className="icon">
                          <img src={item.img} alt="About" />
                        </div>
                        <div className="content">
                          <h4 className="title">{item.title}</h4>
                          <p>
                            {item.desc}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
